<template>
  <!-- Main Content -->
  <div id="content">
    <!-- Begin Page Content -->
    <div class="container-fluid">
      <!-- Page Heading -->
      <h1 class="h3 mb-2 text-gray-800">Preguntas</h1>
      <!-- DataTales Example -->
      <div class="card shadow mb-8">
        <div class="row">
          <div class="col-md-12">

              <form class="d-none d-sm-inline-block form-inline mr-auto ml-md-12 my-4 my-md-9 mw-100 navbar-search col-md-9">
                <div class="row">
                  <div class="col-3">
                    <div class="input-group">
                      <input type="text" class="form-control bg-light border-0 small" placeholder="Buscar por código único"
                             aria-label="Search" aria-describedby="basic-addon2" v-on:keyup.enter="loadQuery" v-model="search">
                      <div class="input-group-append">
                        <button class="btn btn-primary" type="button" @click="loadQuery">
                          <font-awesome-icon icon="search" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-3">
                    <b-form-group id="input-group-3" label="Curso:  " label-for="input-3">
                      <b-form-select
                        id="input-3"
                        v-model="selectedModule"
                        :options="modules"
                        required
                        @change="this.loadQuery"
                        class="ml-2 mt-2"
                      ></b-form-select>
                    </b-form-group>
                  </div>

                  <div class="col-3">
                    <b-form-group id="input-group-3" label="Estado:  " label-for="input-3">
                      <b-form-select
                        id="input-3"
                        v-model="selectedStatus"
                        :options="[
                          {text: 'Activas', value: 'activas'},
                          {text: 'Inactivas', value: 'inactivas'},
                          {text: 'Todas', value: 'all'}
                        ]"
                        required
                        @change="this.loadQuery"
                        class="ml-2 mt-2"
                      ></b-form-select>
                    </b-form-group>
                  </div>

                  <div class="col-2" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">
                    <div class="text-right">
                      <router-link to="/admin-panel/questions/create">
                        <b-button variant="primary">
                          <font-awesome-icon icon="fas fa-plus-square" />&nbsp;Crear Pregunta
                        </b-button>
                      </router-link>
                    </div>
                  </div>

                </div>

                      <br>

                <div class="row">
                  <div class="col-md-2">
                    <div class="input-group">
                        <b-form-group id="input-group-3" label="Creado por:  " label-for="input-3">
                          <b-form-select
                            id="input-3"
                            v-model="selectedUser"
                            :options="admins"
                            required
                            @change="this.loadQuery"
                            class="ml-2 mt-2"
                          ></b-form-select>
                        </b-form-group>
                      <!-- </div> -->
                    </div>
                  </div>
                </div>

              </form>

          </div>


        </div>
        <div class="card-body">
          <div class="table-responsive">
            <b-table striped hover :items="questionsItems" :fields="fields">

              <!-- A virtual column -->
              <template #cell(actions)="data" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">
                <b-dropdown id="dropdown-1" text="Acciones" class="m-md-1">
                  <b-dropdown-item v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">
                    <router-link :to="{ name: 'QuestionsPreview', params: { id: data.item.id, goBack: $route.query, fromList: true }}" >
                      <font-awesome-icon icon="fas fa-search-plus" />&nbsp;Vista previa
                    </router-link>
                  </b-dropdown-item>

                  <b-dropdown-item> <router-link :to="{ name: 'QuestionsEdit', params: { id: data.item.id}}" >
                    <font-awesome-icon icon="fas fa-edit" />&nbsp;Editar
                  </router-link></b-dropdown-item>

                  <b-dropdown-item @click="enableQuestion(data.item.id)" v-if="userPermission !== 'ROLE_TEACHER'">
                    <a href="#"><font-awesome-icon icon="fas fa-trash"/>&nbsp;
                      <span  v-if="selectedStatus === 'inactivas' || (selectedStatus === 'all' && data.item.status == false)"> Activar</span>
                      <span  v-if="selectedStatus === 'activas' || (selectedStatus === 'all' && data.item.status == true)"> Desactivar</span>
                    </a>
                  </b-dropdown-item>

                  <b-dropdown-item @click="deleteQuestion(data.item.id)" v-if="userPermission !== 'ROLE_TEACHER'">
                    <a href="#"><font-awesome-icon icon="fas fa-delete-left"/>&nbsp;

                      <span> Eliminar</span>
                    </a>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>

            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table"
              @change="this.loadQueryPagination"
            ></b-pagination>
          </div>
        </div>
      </div>

    </div>
    <!-- /.container-fluid -->

  </div>
  <!-- End of Main Content -->
</template>

<script>
import axios from "axios";

export default {
  name: "UsersAdmin",
  data: () => {
    return {
      fields: [
        {
          key: 'uniqueName',
          sortable: true,
          label: "Código",
          class: "w-24"
        },
        {
          key: 'description',
          sortable: true,
          label: "Pregunta",
          class: 'w-24'
        },
        {
          key: 'difficulty.description',
          label: 'Dificultad',
          sortable: true,
          class: 'w-23'
        },
        {
          key: 'createdBy',
          label: 'Creado Por',
          sortable: true,
          class: 'w-25'

        },
        {
          key: 'actions',
          label: '',
          sortable: true,
          class: 'text-center'
        }
      ],
      search: '',
      selectedUser: '',
      questionsItems: [],
      modules: [],
      admins: [],
      selected: null,
      selectedStatus: 'activas',
      selectedModule: null,
      questionsInactiveItems: [],
      currentPage: 1,
      currentInactivePage: 1,
      rows: 10,
      rowsInactive: 10,
      perPage: 10,
      userPermission: '',
      msg: ''
    }
  },
  methods: {
    async loadModules() {

      axios
        .get(
          import.meta.env.VITE_API_BASE_URL + "/api/modules/list",
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          let arr = response.data;
          this.modules.push({text: 'Todos', value: null})
          for (let item of arr) {
            this.modules.push({text: item.description, value: item.id})
          }


        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    enableQuestion(id) {
      let loader = this.$loading.show({});
      axios.post(import.meta.env.VITE_API_BASE_URL + "/api/question/enable/" + id , {questionId: id},{
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        }}).then((result) => {
        this.$router.go();
        console.log(result);
      })
      .catch((err) => {

          if (err.response.data.response === 'se ha alcanzado el maximo de preguntas') {
            this.$toastr.defaultTimeout = 2000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.e(
              "No se puede activar, se ha alcanzado el máximo de preguntas en este simulacro"
            );
            console.log(err.message);
            loader.hide();
          } else {
            this.$toastr.defaultTimeout = 2000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.e(
              "No se puede activar, el simulacro se encuentra visible"
            );
            console.log(err.message);
            loader.hide();
          }
        });
    },
    deleteQuestion(id) {

      if(!confirm("¿Estás seguro que deseas eliminar la pregunta? Esta acción es irreversible")){
        return
      }
      let loader = this.$loading.show({});
      axios.delete(import.meta.env.VITE_API_BASE_URL + "/api/question/delete/" + id ,{
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        }}).then((result) => {
        this.$router.go();
        console.log(result);
      })
      .catch((err) => {
        this.$toastr.defaultTimeout = 2000; // default timeout : 5000
        this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
        this.$toastr.e(
          "No se puede eliminar"
        );
        console.log(err.message);
        loader.hide();

      });
    },
    loadQuery() {
      this.$nextTick(function() {
        this.$router.push({ path: '/admin-panel/questions', query: { search: this.search, searchCreatedBy: this.selectedUser, module: this.selectedModule, questionsPage: 1, questionsInactivePage: this.currentInactivePage, status: this.selectedStatus}});
        this.$router.go();
      });
    },
    loadQueryPagination() {
      this.$nextTick(function() {
        this.$router.push({ path: '/admin-panel/questions', query: { search: this.search , searchCreatedBy: this.selectedUser, module: this.selectedModule, questionsPage: this.currentPage, questionsInactivePage: this.currentInactivePage, status: this.selectedStatus}});
        this.$router.go();
      });
    },
    loadQuestions () {
      let tmpCurrentpage = this.$route.query.questionsPage
      axios
        .get(
          import.meta.env.VITE_API_BASE_URL + "/api/question/",
          {
            params: { page: tmpCurrentpage ? tmpCurrentpage : this.currentPage, size: this.perPage, sort: 'DESC', search:  this.search, searchCreatedBy: this.selectedUser, module: this.selectedModule, questionStatus: this.selectedStatus  },
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          this.questionsItems = response.data.content;
          this.rows = response.data.totalElements;
          if (this.$route.query.questionsPage) {
            this.$nextTick(function() {
              this.currentPage = tmpCurrentpage;
              if(this.questionsItems.length === 0 && this.currentPage > 1) {
                this.currentPage -= 1;
                tmpCurrentpage -= 1;
                this.loadQueryPagination();
              }
            });
          }
        })
        .catch((err) => {
          console.log(err.message);

        });
    },
    loadCreator() {
      axios
        .get(
          import.meta.env.VITE_API_BASE_URL + "/user/admins/",
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          let arr = response.data;
          this.admins.push({text: 'Todos', value: ''})
          for (let item of arr) {
            this.admins.push({text: item.name, value: item.id})
          }
        })
        .catch((err) => {
          console.log(err.message);
        });
    }
  },

  watch: {
    questionsItems: function () {
      const elements = document.getElementsByClassName("MathJax");
      while(elements.length > 0){
        elements[0].parentNode.removeChild(elements[0]);
      }
      if ('MathJax' in window) {
        this.$nextTick(function() {
          window.MathJax.Hub.Config({
            tex2jax: {inlineMath: [['$','$'], ['\\(','\\)']]}
          });
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);

        });
      }
    },
    questionsInactiveItems: function () {
      if ('MathJax' in window) {
        this.$nextTick(function() {
          window.MathJax.Hub.Config({
            tex2jax: {inlineMath: [['$','$'], ['\\(','\\)']]}
          });
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);

        });
      }
    },
  },
  created() {
    if (this.$route.query.search)
      this.search = this.$route.query.search
    if (this.$route.query.searchCreatedBy)
      this.selectedUser = this.$route.query.searchCreatedBy
    if (this.$route.query.module) {
      this.selectedModule = this.$route.query.module
    }
    if (this.$route.query.status) {
      this.selectedStatus = this.$route.query.status
    }
  },
  mounted() {

    this.loadModules();
    this.loadQuestions();
    this.loadCreator();

    this.userPermission =  localStorage.getItem("role")


  },
  beforeMount() {

    window.MathJax.Hub.Config({
      tex2jax: {inlineMath: [['$','$'], ['\\(','\\)']]}
    });
  },
};
</script>

